import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Product
 * @exports Service/Product/LifetimeMortgage/[id]/Criteria
 * @description API Product Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class ProductLifetimeMortgageCriteria {
	/**
	 * @static @name get
	 * @description Get product criteria
	 * @param {Object} id
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`product/lifetime-mortgage/${id}/criteria`);
	}
}
